<div id="checkout-form">
  <div id="card-name-field-container"></div>
  <div id="card-number-field-container"></div>
  <div id="card-expiry-field-container"></div>
  <div id="card-cvv-field-container"></div>

  @if(loaded()) {
    <button mat-raised-button 
      color="primary" class="full-width" 
      id="card-field-submit-button" type="button"
      (click)="onSubmit()" [disabled]="paying()">
      PAY
    </button>
  }
</div>